/* lua.js generated code 0.3.0 */

require("clover/gamePlay/GameplayEventDispatcher")
var Event = require("cocos/framework/components/event")
var UserShareData = require("clover/logic/userShare/UserShareData")
UserShare = xClass("UserShare", Event)
UserShareEventListener = table(
    [0, table([1, "class", UserLevel], [1, "event", UserLevelEvent.WinLevel])],
    [0, table([1, "class", UserLevel], [1, "event", UserLevelEvent.LoseLevel])],
    [0, table([1, "class", UserScore], [1, "event", UserScoreEvent.UpdateScore])],
    [0, table([1, "class", UserRank], [1, "event", UserRankEvent.FriendRank])],
    [0, table([1, "class", UserRank], [1, "event", UserRankEvent.RankExtraInfo])],
    [0, table([1, "class", GameplayEventDispatcher], [1, "event", GameplayEvent.UseMove])],
    [0, table([1, "class", GameplayEventDispatcher], [1, "event", GameplayEvent.Eliminate])]
)
var shareNumPerDay = 5
var instance = null
UserShare.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserShare.new()
    }
    return instance
}
UserShare.prototype.ctor = function () {
    var self = this
    self.levelId = -1
    self.shareClassRef = require("clover/logic/userShare/UserShareEnum")
    self.candidateList = table()
    self.shareList = table()
    self.homeShareList = table()
    self.startLevelHandler = null
    UserShareData.getInstance()
    self.init()
}
UserShare.prototype.init = function () {
    var self = this
    self.startLevelHandler = UserLevel.getInstance().on(UserLevelEvent.StartLevel, handler(self, self.onStartLevel))[1]
}
UserShare.prototype.onStartLevel = function (event) {
    var self = this
    self.cleanData()
    self.levelId = event.levelId
    self.buildCandidate()
    self.startListeners()
    self.onGetEvent(event)
}
UserShare.prototype.runShare = function () {
    var self = this
    if (UserShareData.getInstance().getShareNum() >= shareNumPerDay) {
        self.cleanData()
        return 
    }
    if ($len(self.shareList) === 0) {
        return 
    }
    table.sort(self.shareList, function (a, b) {
        return a.priority < b.priority
    })
    if (self.shareList[1]) {
        self.shareList[1].doShare()
    }
}
UserShare.prototype.runHomeSceneShare = function (callback) {
    var self = this
    if (UserShareData.getInstance().getShareNum() >= shareNumPerDay) {
        self.cleanData()
        if (callback) {
            callback()
        }
        return 
    }
    if ($len(self.homeShareList) === 0) {
        self.cleanData()
        if (callback) {
            callback()
        }
        return 
    }
    table.sort(self.homeShareList, function (a, b) {
        return a.priority < b.priority
    })
    if (self.homeShareList[1]) {
        self.homeShareList[1].doShare(callback)
    } else if (callback) {
        callback()
    }
    self.cleanData()
}
UserShare.prototype.cleanData = function () {
    var self = this
    self.levelId = -1
    self.candidateList = table()
    self.homeShareList = table()
    self.shareList = table()
    self.removeListeners()
}
UserShare.prototype.startListeners = function () {
    var self = this
    var _
    for (var i = 1, v = UserShareEventListener[1]; v; i++, v = UserShareEventListener[i]) {
        [_, v.handler] = v.class.getInstance().on(v.event, handler(self, self.onGetEvent))
    }
}
UserShare.prototype.removeListeners = function () {
    var self = this
    for (var i = 1, v = UserShareEventListener[1]; v; i++, v = UserShareEventListener[i]) {
        if (v.handler) {
            v.class.getInstance().removeEventListener(v.handler)
            v.handler = null
        }
    }
}
UserShare.prototype.buildCandidate = function () {
    var self = this
    for (var i = 1, v = self.shareClassRef[1]; v; i++, v = self.shareClassRef[i]) {
        table.insert(self.candidateList, v.create())
    }
}
UserShare.prototype.onGetEvent = function (event) {
    var self = this
    if (event.levelId && event.levelId !== self.levelId) {
        return 
    }
    self.triggerShare(event)
}
UserShare.prototype.triggerShare = function (event) {
    var self = this
    var tmp = table()
    for (var i = 1, v = self.candidateList[1]; v; i++, v = self.candidateList[i]) {
        if (v.canShare(event)) {
            if (v.homePopup) {
                table.insert(self.homeShareList, v)
            } else {
                table.insert(self.shareList, v)
            }
        } else {
            table.insert(tmp, v)
        }
    }
    self.candidateList = tmp
}
